export default "__VITE_ASSET__d54c1473__"